import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditBlog from "../../components/blog/FormAddEditBlog";
import { useGetBlog } from "../../hooks/blog-posts/useGetBlog";
import LoadingPage from "../../components/global/LoadingPage";

const EditBlogPost = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, blog } = useGetBlog(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/blog");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditBlog isEdit={true} currentData={blog} onSubmitSuccess={handleSuccess} />
        </WrapperSection>
    );
};

export default EditBlogPost;
